import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../components/table/TableOps'
import { DialogTitle, Dialog, DialogContent, DialogActions, Button, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core';
import Http from '../../../Http';
import ACCESS from '../../../ACCESS';

class Pendientes extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'preguia/pendientes', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Recolecciones pendientes', [
        { label: 'Preguía', id: 'id' },
        { label: 'Fecha de recolección', id: 'pg_pro_fecha' },
        { label: 'Fecha de preguía', id: 'pg_fecha_reporte' },
        { label: 'Cliente', id: 'cliente' },
        { label: 'Nombre', id: 'cliente_rsocial' },
        { label: 'Transportista', id: 'transportista_nombre' },
        { label: 'Chofer', id: 'ut_chofer' },
      ], [
        { id: 'asignar', icon: 'assignment', access: [ACCESS.PREGUIA.ASIGNAR_A_TRASNPORTISTA] },
      ]))
    this.table();
    this.loadTransportistas();
  }

  loadTransportistas = async () => {
    let TRes = await Http.get('unidad-transporte/all');
    if (!TRes.error) {
      this.setState({ transportistas: TRes.data })
    }
  }

  action = (id, row) => {
    if (id === 'asignar') {
      this.setState({tdOpen: true, tdRow: row})
    }
  }

  asignarTransportista = async () => {
    const { transportista, tdRow } = this.state;
    if(!transportista) return this.setState({tdOpen: false})
    let Res = await Http.post('preguia/save', {id: tdRow.id, id_unidad_transporte: transportista, pg_estado: 3});
    if(!Res.error) {
      this.setState({tdOpen: false});
      this.table();
    }
  }

  render() {
    var { transportistas, transportista, tdOpen } = this.state;
    transportistas = transportistas ? transportistas : []
    transportista = transportista ? transportista : ''
    return (
      <div>
        <div>
          <this.TableRender />
        </div>

        <div>
          <Dialog onClose={() => { this.setState({tdOpen: false}) }} open={tdOpen ? tdOpen : false}>
            <DialogTitle onClose={() => { this.setState({tdOpen: false}) }}>
              Asignar transportista
            </DialogTitle>
            <DialogContent dividers>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>
                  Transportista
                </InputLabel>
                <Select
                  value={transportista}
                  onChange={(e) => this.setState({ transportista: e.target.value })}
                >
                  {transportistas.map((tra, i) => (
                    <MenuItem key={i} value={tra.id}>{tra.unidad} - {tra.ut_chofer} / {tra.transportista_nombre} </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={() => { this.asignarTransportista() }} color="primary">
                Asignar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    )
  }
}

export default withRouter(Pendientes)
